//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const PlusLight = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="PlusLight"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.66002 2.665C8.66002 2.29773 8.36229 2 7.99502 2C7.62775 2 7.33002 2.29773 7.33002 2.665V7.37001H2.665C2.29773 7.37001 2 7.66774 2 8.03501C2 8.40228 2.29773 8.70001 2.665 8.70001H7.33002V13.335C7.33002 13.7023 7.62775 14 7.99502 14C8.36229 14 8.66002 13.7023 8.66002 13.335V8.70001H13.335C13.7023 8.70001 14 8.40228 14 8.03501C14 7.66774 13.7023 7.37001 13.335 7.37001H8.66002V2.665Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
